import { select, call, takeLatest, takeEvery, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { OrderActions, SeanceActions } from '../constants';
import { OrderApi } from 'src/services/end-points';
import { StoreState } from '../reducers';
import { PaginationService } from '../../services/api-handlers/pagination';
import { groupOrder } from 'src/helpers/order';

import {
    DeleteOrderAction,
    GetOrderAction,
    GetOrdersAction,
    PersistOrderAction,
    CreateFilesOrderAction,
    CreateFilesInOrderAction,
    GetFilesAction,
    DeleteFileOrderAction,
    GetOrdersFullyAction,
} from '../actions/order-actions';
import sortingService from '../../services/sorting';
import {
    handleError,
    resolveApiCall,
    ResolverApiFailure,
    ResolverApiSuccess,
    successType,
} from '../../services/api-handlers/api-resolver';
import { SubmissionError } from 'redux-form';
import { makeFormErrors } from '../../components/redux-form/utils/make-form-errors';
import { convertValuesToFormData } from '../../components/redux-form/utils/values-to-form-data';
import { push } from 'connected-react-router';
import Router from '../../navigation/router';
import routes from '../../navigation/routes';

function* handleFetchOrders(action: GetOrdersAction) {
    const oldData = yield select((state: StoreState) => state.orders.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;
    let filterProps: any = { ...filters };

    if (filterProps?.createdAt) {
        filterProps = {
            ...filters,
            ...filterProps?.createdAt,
        };
        delete filterProps.createdAt;
    }

    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        OrderApi.getOrders({
            status: 1,
            ...filterProps,
            ...sortingService.makeOrderSymfony(
                typeof sorting === 'object' && Object.keys(sorting).length ? sorting : { name: 'asc' },
            ),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleFetchCheckOrders1(action: any) {
    let isDouble: any = false;

    const { filters, sorting, page, itemsPerPage } = action.payload;
    const filterProps: any = { ...filters };
    const { names } = filters;

    for (let i = 0; i < names.length; i++) {
        const result: any = yield OrderApi.getOrders({
            status: 1,
            ...filterProps,
            name: names[i],
            ...sortingService.makeOrderSymfony(
                typeof sorting === 'object' && Object.keys(sorting).length ? sorting : { name: 'asc' },
            ),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        });
        if (result.data.length) {
            isDouble = true;
        }
    }

    isDouble = !isDouble ? 'no' : isDouble;

    const actionResult = {
        payload: { isDouble },
        type: successType(OrderActions.FETCH_CHECK_ORDERS),
    };
    yield put(actionResult);
}
function* handleFetchOrdersFully(action: GetOrdersFullyAction): any {
    const { filters, sorting, itemsPerPage } = action.payload;
    let page: number = action?.payload?.page ? +action.payload.page : 1;
    yield resolveApiCall(
        action,
        () =>
            OrderApi.getOrders({
                status: 1,
                'order[name]': 'asc',
                ...filters,
                order: sortingService.makeOrder(sorting),
                page,
                itemsPerPage: 80,
                pagination: itemsPerPage === -1 ? 0 : 1,
            }),
        function* (data) {
            if (data.payload.length === 80) {
                const actionFiles: GetOrdersFullyAction = {
                    type: OrderActions.FETCH_ORDERS_FULLY,
                    payload: {
                        filters,
                        page: ++page,
                        sorting,
                        itemsPerPage: 80,
                    },
                    all: action.all ? [...action.all, ...data.payload] : [...data.payload],
                };

                yield call(handleFetchOrdersFully, actionFiles);
            } else {
                if (action.all) {
                    const actionResult = {
                        payload: { list: [...action.all, ...data.payload], filters },
                        type: successType(OrderActions.FETCH_ORDERS),
                    };
                    yield put(actionResult);
                } else {
                    const actionResult = {
                        payload: { list: [...data.payload], filters },
                        type: successType(OrderActions.FETCH_ORDERS),
                    };

                    yield put(actionResult);
                }
            }
        },
        function* (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                /*   const actionResult = {
                payload: {},
                type: failureType(SeanceActions.FETCH_SEANCES_CSV),
            };
            yield put(actionResult);*/
            }
            handleError(result);
        },
    );
}

function* handleFetchOrder(action: GetOrderAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, () => OrderApi.getOrder(id));
}

function* handleDeleteOrder(action: DeleteOrderAction) {
    const {
        payload: { id, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        () => OrderApi.deleteOrder(id),
        function () {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistOrder(action: PersistOrderAction) {
    const { payload } = action;
    const {
        data: { id },
        files,
        callbacks,
    } = payload;

    const groupData = groupOrder(payload.data);
    yield resolveApiCall(
        action,
        () => (id ? OrderApi.updateOrder(id, groupData) : OrderApi.createOrder(groupData)),
        function* (data: ResolverApiSuccess) {
            const actionFiles: CreateFilesOrderAction = {
                type: OrderActions.CREATE_FILES_ORDER,
                payload: {
                    id: data.payload.id,
                    files: files.files,
                    callbacks,
                },
            };
            const actionOrders: CreateFilesInOrderAction = {
                type: OrderActions.CREATE_FILES_IN_ORDER,
                payload: {
                    id: data.payload.id,
                    files: files.orderDoc ? files.orderDoc : [],
                    onSuccess: () => false,
                    onError: (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                },
            };
            yield call(handleCreateFilesOrder, actionFiles);
            yield call(handleCreateFilesInOrder, actionOrders);
            yield call(callbacks.resolve);

            toast.success(`Order was successfully ${!id ? 'created' : 'updated'}.`);
            if (!id) {
                yield put(push(Router.generate(routes.ORDERS_LIST, { status: '' })));
            } else {
                yield put(push(Router.generate(routes.ORDER_DETAIL, { id: +id })));
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
            // settle the promise the form awaits, otherwise a failed order blocks the whole submit
            callbacks.reject(result.error);

            /*    if (result.error && result.error.response && result.error.response.status) {
                yield call(
                    callbacks.reject,
                    result.error instanceof SubmissionError
                        ? result.error
                        : new SubmissionError({
                              _error: result.error.message ?? 'Incorrect response',
                              ...makeFormErrors(result.error.response?.data),
                          }),
                );
            }
            handleError(result);*/
        },
    );
}

function* handleGetFilesOrder(action: GetFilesAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, () => OrderApi.getFilesOrder(id));
}

function* handleCreateFilesInOrder(action: CreateFilesInOrderAction) {
    const {
        payload: { id, files, onSuccess, onError },
    } = action;

    const requestFunction = (file: any) => {
        const objToForm = { orderDocFile: file };
        const formData = convertValuesToFormData(objToForm, '');

        return OrderApi.createOrderDoc(formData, id);
    };

    for (let i = 0; i < files.length; i++) {
        if (files[i].id || files[i]?.attach || !files[i].type) {
            continue;
        }
        yield resolveApiCall(
            action,
            () => requestFunction(files[i]),
            function (data: ResolverApiSuccess) {
                if (onSuccess) {
                    onSuccess();
                }
                // yield call(callbacks.resolve);
            },
            function (result: ResolverApiFailure) {
                if (result.error && result.error.response && result.error.response.status) {
                    if (onError) {
                        onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                    }
                }
            },
        );
    }
}

function* handleCreateFilesOrder(action: CreateFilesOrderAction) {
    const {
        payload: { id, files, callbacks },
    } = action;

    for (let i = 0; i < files.length; i++) {
        if (files[i].id || files[i]?.attach) {
            continue;
        }
        const formData = convertValuesToFormData({ order: id, attachFile: files[i] }, '');
        yield resolveApiCall(
            action,
            () => OrderApi.createFilesOrder(formData),
            function* (data: ResolverApiSuccess) {
                yield call(callbacks.resolve);
            },
            function* (result: ResolverApiFailure) {
                if (result.error && result.error.response && result.error.response.status) {
                    yield call(
                        callbacks.reject,
                        result.error instanceof SubmissionError
                            ? result.error
                            : new SubmissionError({
                                  _error: result.error.message ?? 'Incorrect response',
                                  ...makeFormErrors(result.error.response?.data),
                              }),
                    );
                }
                handleError(result);
            },
        );
    }
}

function* handleDeleteFileOrder(action: DeleteFileOrderAction) {
    const {
        payload: { id, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        () => OrderApi.deleteFileOrder(id),
        function (data) {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

export default function* () {
    yield takeEvery(OrderActions.FETCH_ORDERS, handleFetchOrders);
    yield takeEvery(OrderActions.FETCH_CHECK_ORDERS, handleFetchCheckOrders1);
    yield takeLatest(OrderActions.FETCH_ORDERS_FULLY, handleFetchOrdersFully);
    yield takeLatest(OrderActions.FETCH_ORDER, handleFetchOrder);
    yield takeLatest(OrderActions.DELETE_ORDER, handleDeleteOrder);
    yield takeEvery(OrderActions.PERSIST_ORDER, handlePersistOrder);
    yield takeLatest(OrderActions.DELETE_FILE_ORDER, handleDeleteFileOrder);
    yield takeLatest(OrderActions.CREATE_FILES_ORDER, handleCreateFilesOrder);
    yield takeLatest(OrderActions.CREATE_FILES_IN_ORDER, handleCreateFilesInOrder);
    yield takeLatest(OrderActions.FETCH_FILES_ORDER, handleGetFilesOrder);
}
